import { z } from '../zod.js';
import {
  CursorPaginationValidationBaseSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination';
import { PaginatedListSchema } from '../shared/paginatedList';
import { CouponResponseValidationSchema } from './response.js';

export const CouponListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend({
    search: z.string().optional().meta({
      description:
        "Case-insensitive contains match against the coupon's label and code. Searching '10off' matches the code `10OFF`; searching 'summer' matches the label 'Summer sale'. There is no filter for redemption count, expiry, or deleted status — page through and inspect those fields instead.",
    }),
  }),
);

export const GetCouponsResponseValidationSchema = PaginatedListSchema(
  CouponResponseValidationSchema,
);
